import type { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';
import { dehydrate, QueryClient } from '@tanstack/react-query';

import g from 'src/constants/urls';
import { IArticleByGroupDetail } from 'src/interface/ArticleByGroup';
import wrapper from 'src/redux';

const HeadC = dynamic(() => import('src/components/Head'));
const ArticleContainerPraKehamilan = dynamic(() => import('src/containers/PraKehamilan'));
// const ArticleDownloadContainer = dynamic(() => import('src/containers/Download/Articles'));

const PhaseArticle = (props: any) => {
	return (
		<>
			<HeadC
				title="Kumpulan Tips Program Hamil dan Persiapan Kehamilan Sehat"
				description={
					'Temukan artikel, tips, dan panduan lengkap persiapan kehamilan yang sehat' +
					' di HalloBumil. Bantu calon ibu mempersiapkan tubuh dan mental secara optimal.'
				}
			/>
			<ArticleContainerPraKehamilan {...props} />
			{/* <ArticleDownloadContainer /> */}
		</>
	);
};

export const getServerSideProps: GetServerSideProps = wrapper.getServerSideProps(
	(store: any) => async (ctx) => {
		let isError: boolean = false;
		let artikelSec1: any = [];
		let artikelSec2: any = [];
		let artikelSec3: any = [];
		let categoryArtikel: any = [];
		let groupArtikel: any = [];
		const queryClient = new QueryClient();

		const queryUrl = ctx.query;
		const queryPhase = queryUrl.phase === 'pra-kehamilan' ? 'pre-pregnancy' : queryUrl.phase === 'pasca-kehamilan' ? 'post-pregnancy' : 'pregnancy';
		const queryPhaseForGroup = queryUrl.phase === 'pra-kehamilan' ? 'PH1' : queryUrl.phase === 'pasca-kehamilan' ? 'PH3' : 'PH2';
		const newFilter = 'orderby=desc&orderby=show_as_banner%2Cpublish_date%2Ctotal_like&page=1&per_page=4&show_as_banner=true';
		const filters = 'orderby=desc&orderby=show_as_banner%2Cpublish_date%2Ctotal_like&page=1&per_page=4&show_as_banner=true';
		// const filtersLike = 'order=desc&orderby=total_like&per_page=9&page=1';
		try {
			const urlGroup = `${g.API_ARTICLE_SLUG}/group?phase=${queryPhaseForGroup}`;
			const optsGroup = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};

			const grp = await fetch(urlGroup, optsGroup);
			groupArtikel = await grp.json().then((res) => ({ ...res, status: grp.status }));

			const uriCategory = `${g.API_ARTICLE_SLUG}/categories?type=${queryPhase}&filter_groups=${queryUrl.group}`;
			const optsCategory = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};

			const cat = await fetch(uriCategory, optsCategory);
			categoryArtikel = await cat.json().then((res) => ({ ...res, status: cat.status }));

			const firstCategory = categoryArtikel.data.records;

			const uri = `${g.API_ARTICLE}/pre-pregnancy?group=promil&category=${firstCategory[0]?.slug}&${newFilter}`;
			const opts = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};

			const s1 = await fetch(uri, opts);
			artikelSec1 = await s1.json().then((res) => ({ ...res, status: s1.status }));

			const uriS2 = `${g.API_ARTICLE}/pre-pregnancy?group=promil&category=${firstCategory[0]?.slug}&${filters}`;
			const optsS2 = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};

			const s2 = await fetch(uriS2, optsS2);
			artikelSec2 = await s2.json().then((res) => ({ ...res, status: s2.status }));

			const uriS3 = `${g.API_ARTICLE}/pre-pregnancy?group=promil&category=${firstCategory[0]?.slug}&${filters}`;
			const optsS3 = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};

			const s3 = await fetch(uriS3, optsS3);
			artikelSec3 = await s3.json().then((res) => ({ ...res, status: s3.status }));

		} catch (err: any) {
			if (err?.status === 400) {
				isError = true;
			} else {
				throw err;
			}
		}
		const article: IArticleByGroupDetail[] =
			store.getState().articleByGroup.articleByCategory?.data?.records;

		if (!article && isError) return { notFound: true };
		return {
			props: {
				dehydratedState: dehydrate(queryClient),
				card: true,
				isWhiteBackground: false,
				JsonLd: {
					organization: true,
					breadcrumbs: true,
				},
				pageHeaderContent: {
					title: 'pra kehamilan',
					breadcrumbs: [
						{ label: 'Artikel ', navigatePath: '/artikel' },
						{ label: 'Pra Kehamilan', navigatePath: '/pra-kehamilan' },
					],
				},
				section1: artikelSec1.data.records || [],
				section2: artikelSec2.data.records || [],
				section3: artikelSec3.data.records || [],
				category: categoryArtikel.data.records || [],
				group: groupArtikel.data.records || [],
			},
		};
	},
);

export default PhaseArticle;
